<template>
    <div
        class="order-status"
        :class="{
            'order-status--cancelled': order.current_status === ORDER_STATUS.CANCELLED,
            'order-status--delivered': order.current_status === ORDER_STATUS.SENT_TO_BUYER }"
        >
        <template v-if="order.current_status === ORDER_STATUS.CANCELLED">Canceled</template>
        <template v-else-if="order.current_status === ORDER_STATUS.SENT_TO_BUYER">Tickets Ready</template>
        <template v-else>Processing</template>
    </div>
</template>

<script>
import { ORDER_STATUS } from '../constants.js'
export default {
    created () {
        this.ORDER_STATUS = ORDER_STATUS
    },
    props: {
        order: {
            required: true,
            type: Object
        }
    }
}
</script>

<style lang="postcss" scoped>
.order-status {
    color: #F8CC01;
    font-size: 18px;
    font-weight: 600;
    &.order-status--cancelled {
        color: #CC2427;
    }

    &.order-status--delivered {
        color: #128020;
    }
}
</style>
